import * as yup from 'yup';
import { YEmailValidate, YSmsCodeValidate } from '../yupValidators';
export const loginInitialValues = {
  email: '',
  password: ''
};
export const mfaLoginInitialValues = {
  verificationCode: ''
};
export const loginSchema = yup.object({
  email: YEmailValidate,
  password: yup.string().trim().required()
});
export const mfaLoginSchema = yup.object().shape({
  verificationCode: YSmsCodeValidate
});